export default __webpack_public_path__ + "static/media/move_down_disabled.478f615f.svg";